import Axios from 'axios';
import { all, fork, takeEvery } from 'redux-saga/effects';
import {
	PAYMENT_METHODS_CREATE,
	PAYMENT_METHODS_UPDATE,
	PAYMENT_METHODS_FIND_ALL,
	PAYMENT_METHODS_GET_DETAILS,
} from 'Constants/actionTypes';
import { apiUrl } from 'Constants/defaultValues';
import { defaultFetchDataFunc } from 'Util/Saga';
import {
	paymentMethodsCreateSuccess,
	paymentMethodsCreateFail,
	paymentMethodsUpdateSuccess,
	paymentMethodsUpdateFail,
	paymentMethodsFindAllSuccess,
	paymentMethodsFindAllFail,
	paymentMethodsGetDetailsSuccess,
	paymentMethodsGetDetailsFail,
} from './actions';

export function* watchPaymentMethodsCreate() {
	yield takeEvery(PAYMENT_METHODS_CREATE, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.post(`${apiUrl}/paymentMethod/create`, data);
			return response.data;
		},
		paymentMethodsCreateSuccess,
		paymentMethodsCreateFail
	));
}

export function* watchPaymentMethodsUpdate() {
	yield takeEvery(PAYMENT_METHODS_UPDATE, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.put(`${apiUrl}/paymentMethod/update`, data);
			return response.data;
		},
		paymentMethodsUpdateSuccess,
		paymentMethodsUpdateFail
	));
}

export function* watchPaymentMethodsFindAll() {
	yield takeEvery(PAYMENT_METHODS_FIND_ALL, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.get(`${apiUrl}/paymentMethod/findAll`, data);
			return response.data;
		},
		paymentMethodsFindAllSuccess,
		paymentMethodsFindAllFail
	));
}

export function* watchPaymentMethodsGetDetails() {
	yield takeEvery(PAYMENT_METHODS_GET_DETAILS, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.get(`${apiUrl}/paymentMethod/details`, { params: { code: data } });
			return response.data;
		},
		paymentMethodsGetDetailsSuccess,
		paymentMethodsGetDetailsFail
	));
}

export default function* rootSaga() {
	yield all([
		fork(watchPaymentMethodsCreate),
		fork(watchPaymentMethodsUpdate),
		fork(watchPaymentMethodsFindAll),
		fork(watchPaymentMethodsGetDetails),
	]);
}